import React from 'react';
import Banner from '../../../components/Banner/Banner';
import ProductTable from '../../../components/ProductTable/ProductTable';
import './FTO.css';

// Import images
import ftoImage1 from '../../../assets/images/IMG_2417.jpg';
import ftoImage2 from '../../../assets/images/IMG_2418-1.jpg';

const FTO = () => {
  // Data for first table (FTOMC01)
  const table1Headers = [
    { text: "Code", colspan: 1 },
    { text: "ÖZELLİKLER", colspan: 1 },
    { text: "PAKET İÇERİK SAYISI", colspan: 1 },
    { text: "PAKET FİYATI (TL)", colspan: 1 },
  ];
  
  const table1Rows = [
    [
      { content: "TKN</br> FTOMC01", rowspan: 3 },
      { content: "Rs &lt; 10 ohm/kare<br><span style=\"color: #ff0000;\">25 mm x 75 mm</span><br>2.2 mm kalınlık<br>1 Paket cam ihtiva eder<br>Tek yüzeyi kaplamalıdır.<br>Pilkington TEC 8 markalıdır.", rowspan: 3 },
      { content: "<strong><span style=\"color: #000000;\">5</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">1560</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">20</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">5248</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">50</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">11960</span></strong>" },
    ]
  ];
  
  // Data for second table (FTOMC02)
  const table2Headers = [
    { text: "Code", colspan: 1 },
    { text: "ÖZELLİKLER", colspan: 1 },
    { text: "PAKET İÇERİK SAYISI", colspan: 1 },
    { text: "PAKET FİYATI (TL)", colspan: 1 },
  ];
  
  const table2Rows = [
    [
      { content: "TKN</br> FTOMC02", rowspan: 3 },
      { content: "Rs &lt; 10 ohm/kare<br><span style=\"color: #ff0000;\">100 mm x 100 mm</span><br>2.2 mm kalınlık<br>1 Paket cam ihtiva eder<br>Tek yüzeyi kaplamalıdır.<br>Pilkington TEC 8 markalıdır.", rowspan: 3 },
      { content: "<strong><span style=\"color: #000000;\">5</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">Lütfen irtibata geçiniz.</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">10</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">12744</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">50</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">Lütfen irtibata geçiniz.</span></strong>" },
    ]
  ];
  
  // Data for third table (FTOMC03)
  const table3Headers = [
    { text: "Code", colspan: 1 },
    { text: "ÖZELLİKLER", colspan: 1 },
    { text: "PAKET İÇERİK SAYISI", colspan: 1 },
    { text: "PAKET FİYATI (TL)", colspan: 1 },
  ];
  
  const table3Rows = [
    [
      { content: "TKN</br> FTOMC03", rowspan: 3 },
      { content: "Rs &lt; 10 ohm/kare<br><span style=\"color: #ff0000;\">200 mm x 200 mm</span><br>2.2 mm kalınlık<br>1 Paket cam ihtiva eder<br>Tek yüzeyi kaplamalıdır.<br>Pilkington TEC 8 markalıdır.", rowspan: 3 },
      { content: "<strong><span style=\"color: #000000;\">5</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">Lütfen irtibata geçiniz.</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">20</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">Lütfen irtibata geçiniz.</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">50</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">Lütfen irtibata geçiniz.</span></strong>" },
    ]
  ];
  
  // Data for fourth table (FTOFC01)
  const table4Headers = [
    { text: "Code", colspan: 1 },
    { text: "ÖZELLİKLER", colspan: 1 },
    { text: "PAKET İÇERİK SAYISI", colspan: 1 },
    { text: "PAKET FİYATI (TL)", colspan: 1 },
  ];
  
  const table4Rows = [
    [
      { content: "TKN</br> FTOFC01", rowspan: 3 },
      { content: "Rs &lt; 15 ohm/kare<br><span style=\"color: #ff0000;\">25 mm x 75 mm</span><br>4.0 mm kalınlık<br>1 Paket cam ihtiva eder<br>Tek yüzeyi kaplamalıdır.", rowspan: 3 },
      { content: "<strong><span style=\"color: #000000;\">5</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">1056</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">20</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">3640</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">50</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">8320</span></strong>" },
    ]
  ];
  
  // Data for fifth table (FTOFC02)
  const table5Headers = [
    { text: "Code", colspan: 1 },
    { text: "ÖZELLİKLER", colspan: 1 },
    { text: "PAKET İÇERİK SAYISI", colspan: 1 },
    { text: "PAKET FİYATI (TL)", colspan: 1 },
  ];
  
  const table5Rows = [
    [
      { content: "TKN</br> FTOFC02", rowspan: 3 },
      { content: "Rs &lt; 15 ohm/kare<br><span style=\"color: #ff0000;\">100 mm x 100 mm</span><br>4.0 mm kalınlık<br>1 Paket cam ihtiva eder<br>Tek yüzeyi kaplamalıdır.", rowspan: 3 },
      { content: "<strong><span style=\"color: #000000;\">5</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">Lütfen irtibata geçiniz.</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">20</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">Lütfen irtibata geçiniz.</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">50</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">Lütfen irtibata geçiniz.</span></strong>" },
    ]
  ];
  
  // Data for sixth table (FTOFC03)
  const table6Headers = [
    { text: "Code", colspan: 1 },
    { text: "ÖZELLİKLER", colspan: 1 },
    { text: "PAKET İÇERİK SAYISI", colspan: 1 },
    { text: "PAKET FİYATI (TL)", colspan: 1 },
  ];
  
  const table6Rows = [
    [
      { content: "TKN</br> FTOFC03", rowspan: 3 },
      { content: "Rs &lt; 15 ohm/kare<br><span style=\"color: #ff0000;\">200 mm x 200 mm</span><br>4.0 mm kalınlık<br>1 Paket cam ihtiva eder<br>Tek yüzeyi kaplamalıdır.", rowspan: 3 },
      { content: "<strong><span style=\"color: #000000;\">5</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">Lütfen irtibata geçiniz.</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">20</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">Lütfen irtibata geçiniz.</span></strong>" },
    ],
    [
      { content: "<strong><span style=\"color: #000000;\">50</span></strong>" },
      { content: "<strong><span style=\"color: #000000;\">Lütfen irtibata geçiniz.</span></strong>" },
    ]
  ];

  return (
    <>
      <Banner title="FTO Kaplamalar" />
      
      <div className="bizler_section_wrapper">
        <div className="container content-container">
          <div className="col-lg-12 col-md-12 col-xs-12">
            <div className="fto-content">
              <section className="pricing-note">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h5 className="note-title">Fiyatlara %20 KDV eklenecektir.</h5>
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4 className="product-title">Florin doped Kalay Oksit (FTO) Kaplı Cam</h4>
                      <ProductTable 
                        headers={table1Headers}
                        rows={table1Rows}
                        className="table-1"
                      />
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <ProductTable 
                        headers={table2Headers}
                        rows={table2Rows}
                        className="table-2"
                      />
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <ProductTable 
                        headers={table3Headers}
                        rows={table3Rows}
                        className="table-3"
                      />
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4 className="product-title">Florin doped Kalay Oksit (FTO) Kaplı Cam</h4>
                      <ProductTable 
                        headers={table4Headers}
                        rows={table4Rows}
                        className="table-4"
                      />
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4 className="product-title">Florin doped Kalay Oksit (FTO) Kaplı Cam</h4>
                      <ProductTable 
                        headers={table5Headers}
                        rows={table5Rows}
                        className="table-5"
                      />
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-section">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4 className="product-title">Florin doped Kalay Oksit (FTO) Kaplı Cam</h4>
                      <ProductTable 
                        headers={table6Headers}
                        rows={table6Rows}
                        className="table-6"
                      />
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-images">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="product-image">
                        <img src={ftoImage1} alt="FTO Coated Glass" className="img-fluid" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="product-image">
                        <img src={ftoImage2} alt="FTO Coated Glass" className="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              
              <section className="product-description">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <h5 className="text-center">
                        FTO kaplamalı camların optik geçirgenlik. <br />
                        Sol grafik TEC 8 markalı camdır. Sağdaki grafik standart camdır.
                      </h5>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FTO;